export const RASCUNHO = {
  codigo: 1,
  descricao: "Rascunho",
  cor: "secondary",
  icone: "fa fa-file"
};

export const ABERTO = {
  codigo: 2,
  descricao: "Aberto",
  cor: "primary",
  icone: "fa fa-folder-open"
};

export const FECHADO = {
  codigo: 3,
  descricao: "Fechado",
  cor: "success",
  icone: "fa fa-check"
};

export const CANCELADO = {
  codigo: 4,
  descricao: "Cancelado",
  cor: "danger",
  icone: "fa fa-ban"
};

export const values = [RASCUNHO, ABERTO, FECHADO, CANCELADO];

export const valueOf = codigo => {
  for (let i = 0; i < values.length; i++) {
    const cs = values[i];
    if (cs.codigo === codigo) {
      return cs;
    }
  }

  return RASCUNHO;
};

export const isRascunho = codigo => RASCUNHO.codigo === codigo;



// WEBPACK FOOTER //
// ./src/constantes/CsSituacaoOrcamento.js